import React from 'react'

const IconImprovement = ({ style = {}, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      {...props}>
      <path
        d="M20.724 17.633l-10.117-9a2.512 2.512 0 0 0-2.19 1.868l9.12 10.305.187.187a2.253 2.253 0 1 0 3-3.36zM5.514 9.646c.638 1.027 1.238.855 1.32-.323a2.505 2.505 0 0 1 2.355-2.25c1.208-.037 1.38-.63.383-1.305a2.505 2.505 0 0 1-.75-3.172c.57-1.065.15-1.5-.945-.983a2.505 2.505 0 0 1-3.165-.93c-.638-1.027-1.23-.877-1.32.323a2.505 2.505 0 0 1-2.355 2.25c-1.215.052-1.388.645-.383 1.32a2.505 2.505 0 0 1 .75 3.172c-.57 1.065-.15 1.5.945.983a2.505 2.505 0 0 1 3.165.915zm6.683-5.25l1.005.352a2.13 2.13 0 0 1 1.327 1.373l.323 1.02a.405.405 0 0 0 .75 0l.352-1.005a2.13 2.13 0 0 1 1.373-1.328l1.035-.307a.405.405 0 0 0 0-.75l-1.005-.353a2.13 2.13 0 0 1-1.328-1.372l-.277-1.013a.405.405 0 0 0-.75 0l-.353 1.005a2.13 2.13 0 0 1-1.372 1.328l-1.02.322a.404.404 0 0 0 0 .75l-.06-.022zm-4.26 10.312l-.893-.315a1.89 1.89 0 0 1-1.177-1.215l-.285-.9a.36.36 0 0 0-.683 0l-.315.893a1.89 1.89 0 0 1-1.207 1.155l-.9.285a.36.36 0 0 0 0 .682l.892.315a1.89 1.89 0 0 1 1.133 1.215l.285.9a.36.36 0 0 0 .682 0l.315-.892A1.89 1.89 0 0 1 7 15.653l.9-.285a.36.36 0 0 0 0-.682l.038.022z"
        fill="#FDAE38"
      />
    </svg>
  )
}

export default IconImprovement
